module.exports = __webpack_public_path__ + "img/convenio-de-practicas1.9696c66e.png";